import { ApiCourseRequest } from "data/queries/ApiCourse";


export const verifySlugAlredyExist = async (slug: string, excludeId?: number): Promise<boolean> => {
  try {
    const response = await ApiCourseRequest<{ Course?: { slug: string, id: number } }>({
      query: `query Query($slug: String) { Course(slug: $slug) { slug id } }`,
      variables: { slug },
    });
    if (!response?.data?.data?.Course?.slug) return false
    if (!!excludeId && excludeId === response?.data?.data?.Course?.id) return false

    return true;
  } catch {
    return false
  }
}

export const verifySlug = async (
  slug: string,
  excludeId?: number,
  error?: {
    message?: string,
    messageField?: string,
    instancePath?: string,
    keyword?: string,
  },
): Promise<void> => {
  const alredyExist = await verifySlugAlredyExist(slug, excludeId)
  if (alredyExist) {
    throw {
      message: error?.message || "Slug inválido",
      errors: [
        {
          instancePath: error?.instancePath || "/slug",
          message: error?.message || "Inválido. Já existe um curso com esse slug",
          schemaPath: error?.instancePath || "/slug",
          keyword: error?.keyword || "slug",
          params: {},
        },
      ],
    };
  }

}